import React from 'react'
import PropTypes from 'prop-types'
import Validator from 'validatorjs'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Input from 'components/Input'
import Button from 'components/Button'

import { changeWorkshop } from '../actions'
import { statusChanged } from 'components/RequestStatus/actions'

import { WORKSHOPS_URL } from 'constants'

export class AddWorkshop extends BaseComponent {
  static validationRules = {
    name: 'string|required|min:2',
    address: 'string|required|min:5',
    phone: 'string|required|max:14'
  }

  constructor() {
    super()

    this.state = {
      buttonProps: {
        disabled: true
      },
      formData: {
        name: '',
        address: '',
        phone: ''
      },
      errors: {}
    }

    this._bind('_handleSubmit', '_handleChange', '_validate')
  }

  _handleSubmit(e) {
    e.preventDefault()

    this.props.updateRequestStatus('progress', 'Creando taller')
    request(WORKSHOPS_URL, {
      method: 'POST',
      body: {
        ...this.state.formData
      }
    }).then((res) => {
      this.props.updateRequestStatus(res.status, res.message)
      this.props.changeWorkshop({value: res.workshop.id, label: res.workshop.name})
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos crear el taller')
    })
    this.context.toggleModal(false)
  }

  _handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e.target.name, e.target.value)
  }

  _validate(name, value) {
    const formData = {
      ...this.state.formData,
      [name]: value
    }
    const validator = new Validator(formData, AddWorkshop.validationRules)
    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      }
    })
  }

  render() {
    const formData = this.state.formData

    return (
      <div id="AddWorkshop" className="EditModal Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>Crear Taller</h1>
          <span className="material-icons close-button" onClick={() => this.context.toggleModal(false)}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex EditModal__form">
          <p>Ingresa los datos del taller</p>
          <Input  label="Nombre"
                  placeholder="Escribe el nombre*"
                  onChange={this._handleChange}
                  name="name"
                  type="text"
                  value={formData.name}
                  errors={this.state.errors.name} />

          <Input  label="Dirección"
                  placeholder="Escribe la dirección*"
                  onChange={this._handleChange}
                  name="address"
                  type="text"
                  value={formData.address}
                  errors={this.state.errors.address} />

          <Input  label="Teléfono"
                  placeholder="Escribe el teléfono*"
                  onChange={this._handleChange}
                  name="phone"
                  type="text"
                  value={formData.phone}
                  errors={this.state.errors.phone} />
          <div className="controls d-flex justify-content-center">
            <Button type="submit"
                    size="big"
                    buttonType="primary"
                    className="button-add-workshop"
                    {...this.state.buttonProps}>Agegar nuevo taller</Button>
          </div>
        </form>
      </div>
    )
  }
}

AddWorkshop.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
}


const mapDispatchToProps = (dispatch) => {

  return {
    changeWorkshop: (workshop) => dispatch(changeWorkshop(workshop)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(null, mapDispatchToProps)(AddWorkshop)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/Workshop/SelectWorkshop/AddWorkshop.js